export const parseQueryString = function(param) {
  if (param == null) return "";
  let pairs = [],
    str = "";
  for (var prop in param) {
    if (param.hasOwnProperty(prop)) {
      var k = encodeURIComponent(prop),
        v = encodeURIComponent(param[prop]);
      pairs.push(k + "=" + v);
    }
  }
  str = "?" + pairs.join("&");
  return str;
};
//url参数转对象
export const parseQuery = query => {
  // query = query.toLowerCase();
  const reg = /([^=&\s]+)[=\s]*([^=&\s]*)/g;
  const obj = {};
  while (reg.exec(query)) {
    obj[RegExp.$1.toLowerCase()] = RegExp.$2;
  }
  return obj;
};
export const cookie = {
  set: function(key, val, time) {
    //设置cookie方法
    var date = new Date(); //获取当前时间
    var expiresDays = time; //将date设置为n天以后的时间
    date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); //格式化为cookie识别的时间
    document.cookie = key + "=" + val + ";expires=" + date.toGMTString(); //设置cookie
  },
  get: function(key) {
    //获取cookie方法
    /*获取cookie参数*/
    var getCookie = document.cookie.replace(/[ ]/g, ""); //获取cookie，并且将获得的cookie格式化，去掉空格字符
    var arrCookie = getCookie.split(";"); //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
    var tips; //声明变量tips
    for (var i = 0; i < arrCookie.length; i++) {
      //使用for循环查找cookie中的tips变量
      var arr = arrCookie[i].split("="); //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
      if (key === arr[0]) {
        //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
        tips = arr[1]; //将cookie的值赋给变量tips
        break; //终止for循环遍历
      }
    }
    return tips;
  },
  delete: function(key) {
    //删除cookie方法
    var date = new Date(); //获取当前时间
    date.setTime(date.getTime() - 10000); //将date设置为过去的时间
    document.cookie = key + "=v; expires =" + date.toGMTString(); //设置cookie
  }
};
//秒格式化
export const secondsTypefy = seconds => {
  return `${fixZero(Math.floor(seconds / 60), 2)}:${fixZero(
    Math.ceil(seconds % 60),
    2
  )}`;
};
//补零
export const fixZero = (value, num) => {
  const len = ("" + value).length;
  return Array(num > len ? num - len + 1 || 0 : 0).join(0) + value;
};

//计算日期 传入秒
export const computeDate = (startTime, diffTime) => {
  const date = new Date((startTime + diffTime * 24 * 3600) * 1000);
  return `${date.getFullYear()}年${fixZero(date.getMonth() + 1, 2)}月${fixZero(
    date.getDate(),
    2
  )}日`;
};

// 日期格式化
export const parseDate = timestamp => {
  if (timestamp) {
    const date = new Date(timestamp);
    return `${date.getFullYear()}-${fixZero(date.getMonth() + 1, 2)}-${fixZero(
      date.getDate(),
      2
    )}`;
  }
};

//获取元素的纵坐标
export const getTop = e => {
  var offset = e.offsetTop;
  if (e.offsetParent != null) offset += getTop(e.offsetParent);
  return offset;
};

// 获取元素的横坐标
export const getLeft = e => {
  var offset = e.offsetLeft;
  if (e.offsetParent != null) offset += getLeft(e.offsetParent);
  return offset;
};

// 获取dom位置信息
export const getDomPosition = function(dom) {
  if (dom) {
    console.log("----");
    return Array.from(dom).map(node => {
      let style = null;
      if (window.getComputedStyle) {
        style = window.getComputedStyle(node, null); // 非IE
      } else {
        style = node.currentStyle; // IE
      }
      const { top: t, left: l } = node.getBoundingClientRect() || {};
      // const top = parseInt(node.offsetTop, 10);     //相对于父元素
      // const left = parseInt(node.offsetLeft, 10);   //相对于父元素
      const top = parseInt(t, 10); // 相对于窗口
      const left = parseInt(l, 10); // 相对于窗口
      const width = parseInt(style.width, 10);
      const height = parseInt(style.height, 10);
      return { left, top, width, height };
    });
  } else {
    return [];
  }
};

// 解决数据中有单引号问题
export const encodeParams = params => {
  const dataJson = JSON.stringify(params);
  return dataJson.replace(/'/, "$d$");
};
export const decodeParams = str => {
  let dataJson = str.replace(/\$d\$/g, "'");
  return JSON.parse(dataJson);
};

// 重写storage
export const myStorage = {
  storage: window.localStorage,
  init: function() {
    window.myStorageData = {};
  },
  setItem: function(keyName, keyValue) {
    this.storage.setItem(keyName, keyValue);
    window.myStorageData[keyName] = keyValue;
  },
  getItem: function(keyName) {
    let value = this.storage.getItem(keyName);
    if (!value) value = window.myStorageData && window.myStorageData[keyName];
    return value;
  },
  removeItem: function(keyName) {
    this.storage.removeItem(keyName);
    window.myStorageData[keyName] = null;
  }
};



// WEBPACK FOOTER //
// ./src/utils/tools.js